import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {HomeComponent} from './home-container.component';
import {HomeRoutingModule} from './home-routing.module';
import {ModalModule} from '../../shared/components/modal/modal.module';
import {RecipeListCardModule} from '../../shared/components/recipe/list-card/recipe-list-card.module';
import {RecipeCardModule} from '../../shared/components/recipe/card/recipe-card.module';
import { BlogCardHomeModule } from 'src/app/shared/components/blog/cardhome/blog-card-home.module';
import {TooltipModule} from '../../core/pipe/tooltip.module';
import {UserCardModule} from '../../shared/components/user/card/user-card.module';


@NgModule({
  declarations: [
    HomeComponent
  ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        ModalModule,
        RecipeListCardModule,
        RecipeCardModule,
        BlogCardHomeModule,
        TooltipModule,
        UserCardModule,
        NgOptimizedImage
    ]
})
export class HomeModule {
}
